// extracted by mini-css-extract-plugin
module.exports = {"RV-B":"B_RV-B__1yxjM"};